import { createStyles } from "@mantine/core";
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { NavLinkType } from "../../../type/navlink.types";

const useStyles = createStyles((theme, _params, getRef) => {
  const icon = getRef("icon");

  return {
    link: {
      display: "flex",
      alignItems: "center",
      textDecoration: "none",
      fontSize: theme.fontSizes.md,
      color:
        theme.colorScheme === "dark"
          ? theme.colors.dark[1]
          : theme.colors.gray[7],
      padding: `${theme.spacing.xs}px ${theme.spacing.sm}px`,
      borderRadius: theme.radius.sm,
      fontWeight: 500,

      "&:hover": {
        backgroundColor:
          theme.colorScheme === "dark"
            ? theme.colors.dark[6]
            : theme.colors.gray[0],
        color: theme.colorScheme === "dark" ? theme.white : theme.black,

        [`& .${icon}`]: {
          color: theme.colorScheme === "dark" ? theme.white : theme.black,
        },
      },
    },

    linkIcon: {
      ref: icon,
      color:
        theme.colorScheme === "dark"
          ? theme.colors.dark[2]
          : theme.colors.gray[6],
      marginRight: theme.spacing.sm,
    },

    linkActive: {
      "&, &:hover": {
        backgroundColor: theme.fn.variant({
          variant: "light",
          color: theme.primaryColor,
        }).background,
        color: theme.fn.variant({ variant: "light", color: theme.primaryColor })
          .color,
        [`& .${icon}`]: {
          color: theme.fn.variant({
            variant: "light",
            color: theme.primaryColor,
          }).color,
        },
      },
    },
  };
});

const NavLink = ({
  href,
  children,
  value,
  active,
  setActive,
}: {
  href: string;
  children: ReactNode;
  value: NavLinkType;
  active: string;
  setActive: (label: string) => void;
}) => {
  const { classes, cx } = useStyles();

  return (
    <Link
      to={href}
      className={cx(classes.link, {
        [classes.linkActive]: value.label === active,
      })}
      onClick={() => {
        setActive(value.label);
      }}
    >
      <value.icon className={classes.linkIcon} strokeWidth={1.5} />
      {children}
    </Link>
  );
};

export default NavLink;
